module.exports = __webpack_public_path__ + "img/Logo.40245905.png";